<template>
  <div class="body">
    <Menu title="项目空间" :menulist="menulist" :isreturn="true" :active="isActivate" @menu-click="handleMenuClick"
      @status-change="handleStatusChange" :menuIndex="nowIndex"></Menu>
    <div class="center">
      <DashboardHeader :sidebarCollapsed="sidebarCollapsed" :navbarFixed="navbarFixed"
        @toggleSettingsDrawer="toggleSettingsDrawer" @toggleSidebar="toggleSidebar"></DashboardHeader>
      <div class="centerbody custom-scrollbar">
        <!-- <div class="test" @click="isActivate=!isActivate">test</div> -->
        <router-view />
      </div>
    </div>
    <div :class="isclose ? 'chat' : 'chat nc'">
      <chat v-if="isclose"></chat>
    </div>
  </div>
</template>

<script>
import DashboardHeader from "../components/Headers/DashboardHeader"
import Menu from '@/components/Menu2.vue'
import chat from '@/components/chat.vue'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  components: {
    Menu, // 注册组件
    chat,
    DashboardHeader
  },
  data () {
    return {
      isclose: true,
      menuIndex: 0,
      isActivate: true,
      menulist: [
        {
          img1: require('@/assets/images/mn1.png'),
          img2: require('@/assets/images/mn1-2.png'),
          text: '空间首页'
        },
        {
          img1: require('@/assets/images/mn1.png'),
          img2: require('@/assets/images/mn1-2.png'),
          text: '创意生成'
        },
        {
          img1: require('@/assets/images/mn1.png'),
          img2: require('@/assets/images/mn1-2.png'),
          text: '智能写作'
        },
        {
          img1: require('@/assets/images/mn2.png'),
          img2: require('@/assets/images/mn2-2.png'),
          text: '脚本扩写'
        },
        // {
        //   img1: require('@/assets/images/mn3.png'),
        //   img2: require('@/assets/images/mn3-2.png'),
        //   text: '人物塑造'
        // },
        // {
        //   img1: require('@/assets/images/mn4.png'),
        //   img2: require('@/assets/images/mn4-2.png'),
        //   text: '场景规划'
        // },
        // {
        //   img1: require('@/assets/images/mn5.png'),
        //   img2: require('@/assets/images/mn5-2.png'),
        //   text: '道具生成'
        // },
        {
          img1: require('@/assets/images/mn7.png'),
          img2: require('@/assets/images/mn7-2.png'),
          text: '智能分镜'
        },
        // {
        //   img1: require('@/assets/images/mn8.png'),
        //   img2: require('@/assets/images/mn8-2.png'),
        //   text: '配音/旁白'
        // },
        // {
        //   img1: require('@/assets/images/mn9.png'),
        //   img2: require('@/assets/images/mn9-2.png'),
        //   text: '背景音乐'
        // },
        // {
        //   img1: require('@/assets/images/mn10.png'),
        //   img2: require('@/assets/images/mn10-2.png'),
        //   text: '视频生成'
        // },
        {
          img1: require('@/assets/images/mn11.png'),
          img2: require('@/assets/images/mn11-2.png'),
          text: '汇报PPT'
        },
        // {
        //   img1: require('@/assets/images/mn12.png'),
        //   img2: require('@/assets/images/mn12-2.png'),
        //   text: '团队协同'
        // },
        {
          img1: require('@/assets/images/mn6.png'),
          img2: require('@/assets/images/mn6-2.png'),
          text: '素材管理'
        }
      ],
      sidebarCollapsed: true,
      navbarFixed: false,
      nowIndex: 0
    }
  },
  created () {
    let path = this.$route.fullPath
    if (path.includes('/project1')) {
      this.nowIndex = 0
    } else if (path.includes('/project2')) {
      this.nowIndex = 1
    } else if (path.includes('/project3')) {
      this.nowIndex = 2
    } else if (path.includes('/project4')) {
      this.nowIndex = 3
    } else if (path.includes('/project5')) {
      this.nowIndex = 4
    } else if (path.includes('/project6')) {
      this.nowIndex = 5
    }
  },
  mounted () {

  },
  watch: {
    $route (to, from) {
      this.sidebarCollapsed = true
      let path = this.$route.fullPath
      console.log(this.$route, 'path');

      // this.change()
      if (path.includes('/project1')) {
        this.nowIndex = 0
      } else if (path.includes('/project2')) {
        console.log('执行');

        this.nowIndex = 1
      } else if (path.includes('/project3')) {
        this.nowIndex = 2
      } else if (path.includes('/project4')) {
        this.nowIndex = 3
      } else if (path.includes('/project5')) {
        this.nowIndex = 4
      } else if (path.includes('/project6')) {
        this.nowIndex = 5
      }
    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     this.change()
  //   }
  // },
  methods: {
    // 2. 监听菜单点击事件（组件内部触发）
    handleMenuClick (data) {
      console.log('选中的菜单索引：', data.index)
      // console.log('选中的菜单数据：', data.selectedItem)
      // 可在这里处理父组件的业务逻辑（如切换页面、请求数据等）
      // if( data.index==11){
      //   location.href=`/pc/#/knowledge?id=${this.$route.query.id}`
      //   return
      // }
      this.$router.push(`/project${data.index + 1}?id=${this.$route.query.id}`)
      // location.href=`/pc/#/`
    },

    // 3. 监听组件内部 status 变化
    handleStatusChange (status) {
      console.log('菜单组件当前状态：', status)
      // 根据组件状态做后续处理（如显示不同提示、禁用其他按钮等）
    },
    change () {
      // 对路由变化作出响应...
      const pathurl = [
        // '/main/index/index2',
        '/main/project']
      let ispage = false
      for (let i = 0; i < pathurl.length; i++) {
        if (this.$route.fullPath.includes(pathurl[i])) {
          ispage = true
          break
        }
      }
      if (ispage) {
        this.openChat()
      } else {
        this.closeChat()
      }
    },
    closeChat () {
      this.isclose = false
    },
    openChat () {
      this.isclose = true
    },
    toggleSidebar (value) {
      this.sidebarCollapsed = value
    },
    toggleSettingsDrawer (value) {
      this.showSettingsDrawer = value
    },
  }
}
</script>
<style lang="scss" scoped>
.body {
  display: flex;
  height: 100vh;
}

.center {
  flex: 1;
  background-color: #fff;

  .centerbody {
    margin-top: 10px;
    height: calc(100vh - 80px);
    overflow: auto;
  }
}

.chat {
  width: 360px;
  background: #F8F8F8;
  height: 100%;
  // transition: all .2s linear;
}

.nc {
  width: 0;
}
</style>
